import React from "react";
import { Helmet } from "react-helmet-async";
import { Breadcrumb } from "./Breadcrumb";
import { BREADCRUMBS, HOWTO_SCHEMAS } from "../lib/pageMetadata";

/**
 * <ToolPageMeta /> — single drop-in component for the 7 free tool pages.
 *
 * Renders the visual Breadcrumb and injects the HowTo JSON-LD via Helmet.
 * Page-level meta tags (title, description, canonical) are still owned by
 * the page itself via `usePageMeta` or `<SEO />` so we don't double-inject.
 *
 * Usage:
 *   <ToolPageMeta toolId="subnet-calculator" />
 *
 * Props:
 *   toolId — slug used as the BREADCRUMBS / HOWTO_SCHEMAS key.
 */
export const ToolPageMeta = ({ toolId }) => {
    const crumbs = BREADCRUMBS[toolId];
    const howto = HOWTO_SCHEMAS[toolId];

    if (!crumbs) {
        if (typeof window !== "undefined") {
            // Soft error so a typo is loud in dev but doesn't crash production.
            console.warn(`<ToolPageMeta />: unknown toolId "${toolId}"`);
        }
        return null;
    }

    return (
        <>
            {howto && (
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(howto)}
                    </script>
                </Helmet>
            )}
            <Breadcrumb items={crumbs} />
        </>
    );
};

export default ToolPageMeta;
